module.exports = __webpack_public_path__ + "static/enchanted-logo-1-c3bbacfaadf5c25938f27b00e5db2bb1.png";